import { render, staticRenderFns } from "./bind.vue?vue&type=template&id=1a91abbf&scoped=true&"
import script from "./bind.vue?vue&type=script&lang=js&"
export * from "./bind.vue?vue&type=script&lang=js&"
import style0 from "./bind.vue?vue&type=style&index=0&id=1a91abbf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a91abbf",
  null
  
)

export default component.exports